import Vue from 'vue'
import Vuex from 'vuex'
import {listStores, listBrands, listFavorites, listReservations} from "../graphql/queries";
import {PAGE_IDS} from "../utils/constants"
import {process_500_error} from "@/utils/utils"
import router from "../router";
import Vuetify from 'vuetify/lib';
import fakeDataStore from "./fake_data_store";
import {fetchItemsNextTokenGraphQL} from "@/utils/query_all_utils";

Vue.use(Vuex)

const store = new Vuex.Store({
  state: {
    user: null,
    ownerId:null,
    current_role: undefined,
    store_id: undefined,
    brand_id: undefined,
    all_stores: [],
    all_brands: [],
    all_favorites: [],
    all_reservations: [],
    add_user_promise: undefined,
    add_user_email: '',
    initialized: false,
    forced_load: true,
    address: '',
    timezone:'',
    lat: undefined,
    lng: undefined,
    error: '',
    error_timer: undefined,
    allow_action: false,
    drawer_state: true,
    loading: 0,
  },
  mutations: {
    START_LOADING: (state) => state.loading++,
    STOP_LOADING: (state) => state.loading--,
    TOGGLE_DRAWER: (state, val) => state.drawer_state = val,
    SET_ADDRESS: (state, address) => state.address = address,
    SET_LAT: (state, lat) => state.lat = lat,
    SET_LNG: (state, lng) => state.lng = lng,
    SET_OWNERID: (state, ownerId) => state.ownerId = ownerId,
    INITIALIZATION_COMPLETED(state) {
      state.initialized = true
    },
    REINITIALIZE(state) {
      state.initialized = false
    },
    SET_FORCED_LOAD(state, value) {
      state.forced_load = value
    },
    SHOW_ADD_USER_MODAL(state, user_promise) {
      state.add_user_promise = user_promise
      state.add_user_email = ''
    },
    SAVE_ADD_USER_MODAL(state) {
      state.add_user_promise(state.add_user_email)
      state.add_user_promise = undefined
      state.add_user_email = ''
    },
    HIDE_ADD_USER_MODAL(state) {
      state.add_user_promise = undefined
      state.add_user_email = ''
    },
    SET_ADD_USER_EMAIL(state, value) {
      state.add_user_email = value
    },

    SET_USER(state, user) {
      state.user = user
    },
    SET_ALL_STORES(state, all_stores) {
      var stores = []
      for (var store of all_stores) {
        if (state.all_brands.find((item) => item.id == store.brand_id)) {
          stores.push(store)
        }
      }
      state.all_stores = stores
    },
    SET_ALL_FAVORITES(state, all_favorites) {
      state.all_favorites = all_favorites
    },
    SET_ALL_RESERVATIONS(state, all_reservations) {
      state.all_reservations = all_reservations
    },
    SET_ALL_BRANDS(state, all_brands) {
      state.all_brands = all_brands
    },
    SET_ROLE(state, {role, item_id}) {
      switch (role) {
        case 'Visitor':
        case 'System Administrator':
          state.store_id = undefined
          state.brand_id = undefined
          break;
        case 'Security':
        case 'Store Manager':
          state.store_id = item_id
          state.brand_id = undefined
          break;
        case 'Brand Manager':
          state.store_id = undefined
          state.brand_id = item_id
          break;
      }
      state.current_role = role
      localStorage.setItem('role', role)
      localStorage.setItem('role_item_id', item_id)
    },
    REMOVE_BRAND(state, brand_id) {
      state.all_brands = state.all_brands.filter((item) => item.id != brand_id)
    },
    REMOVE_FAVORITE(state, favorite_id) {
      state.all_favorites = state.all_favorites.filter((item) => item.id != favorite_id)
    },
    REMOVE_STORE(state, store_id) {
      state.all_stores = state.all_stores.filter((item) => item.id != store_id)
    },
    UPDATE_BRAND(state, brand) {
      var found_brand = state.all_brands.find((item) => item.id == brand.id)
      for (var key in brand) {
        Vue.set(found_brand, key, brand[key])
      }
    },
    UPDATE_RESERVATION(state, reservation) {
      var found_reservation = state.all_reservations.find((item) => item.id == reservation.id)
      for (var key in reservation) {
        Vue.set(found_reservation, key, reservation[key])
      }
    },
    ADD_BRAND(state, brand) {
      state.all_brands.push(brand)
    },
    ADD_FAVORITE(state, favorite) {
      state.all_favorites.push(favorite)
    },
    ADD_RESERVATION(state, reservation) {
      state.all_reservations.push(reservation)
    },
    UPDATE_STORE(state, store) {
      var found_store = state.all_stores.find((item) => item.id == store.id)
      for (var key in store) {
        Vue.set(found_store, key, store[key])
      }
    },
    ADD_STORE(state, store) {
      state.all_stores.push(store)
    },
    ALLOW_ACTION(state, is_allowed) {
      state.allow_action = is_allowed
    }
  },
  actions: {
    startLoading: ({commit}) => commit('START_LOADING'),
    stopLoading: ({commit}) => commit('STOP_LOADING'),
    showError: ({commit}, error) => {
      commit('SET_ERROR', error)
      if (state.error_timer != undefined) {
        cancelTimer(state.error_timer)
      }
      commit('SET_ERROR_TIMER', setTimeout(function () {
        dispatch('hideError')
      }), 2000)
    },
    hideError: ({commit}) => commit('SET_ERROR', ""),
    setAddress: ({commit}, address) => commit('SET_ADDRESS', address),
    setTimezon:({commit}, address) => commit('SET_TIMEZONE', timezone),
    setLat: ({commit}, lat) => commit('SET_LAT', lat),
    setLng: ({commit}, lng) => commit('SET_LNG', lng),
    setOwnerId: ({commit}, ownerId) => commit('SET_OWNERID', ownerId),
    startForcedLoad: ({commit}, brand) => commit('SET_FORCED_LOAD', true),
    stopForcedLoad: ({commit}, brand) => commit('SET_FORCED_LOAD', false),
    addBrand: ({commit}, brand) => commit('ADD_BRAND', brand),
    addStore: ({commit}, store) => commit('ADD_STORE', store),
    allowAction: ({commit}, is_allowed) => commit('ALLOW_ACTION', is_allowed),
    addFavorite: ({commit}, favorite) => commit('ADD_FAVORITE', favorite),
    addReservation: ({commit}, reservation) => commit('ADD_RESERVATION', reservation),
    updateBrand: ({commit}, brand) => commit('UPDATE_BRAND', brand),
    updateStore: ({commit}, store) => commit('UPDATE_STORE', store),
    updateReservation: ({commit}, reservation) => commit('UPDATE_RESERVATION', reservation),
    removeBrand: ({commit}, brand_id) => commit('REMOVE_BRAND', brand_id),
    removeStore: ({commit}, store_id) => commit('REMOVE_STORE', store_id),
    removeFavorite: ({commit}, favorite) => commit('REMOVE_FAVORITE', favorite),
    setUserEmail: ({commit}, user_email) => commit('SET_ADD_USER_EMAIL', user_email),
    showAddUserModal: ({commit}, promise) => {
      router.push(router.currentRoute.path + "#add_user")
      commit('SHOW_ADD_USER_MODAL', promise)
    },
    hideAddUserModal: ({commit}) => {
      var path = router.currentRoute.path.split("#")[0]
      if (path != router.currentRoute.path) {
        router.replace(path)
      }
      commit('HIDE_ADD_USER_MODAL')
    },
    hideMapModal: ({commit}) => {
      var path = router.currentRoute.path.split("#")[0]
      if (path != router.currentRoute.path) {
        router.replace(path)
      }
    },
    showMapModal: ({commit}) => {
      router.push(router.currentRoute.path + "#map")
    },
    saveAddUserModal: ({commit}) => commit('SAVE_ADD_USER_MODAL'),
    setRole: ({commit}, {role, item_id}) => commit('SET_ROLE', {role, item_id}),
    reinitialize: ({commit, dispatch}, user) => {
      commit('REINITIALIZE')
    },
    reloadReservations: ({commit, dispatch, getters}, user) => {
      fetchItemsNextTokenGraphQL(listReservations, {
        limit: 10000, filter: {owner: {eq: getters.currentUser.username}}
      }).then((res) => {
        commit('SET_ALL_RESERVATIONS', res)
      })

    },
    reloadFavorites: ({commit, dispatch, getters}, user) => {
      fetchItemsNextTokenGraphQL(listFavorites, {
        limit: 10000,
        filter: {owner: {eq: getters.currentUser.username}}
      }).then((res) => {
        commit('SET_ALL_FAVORITES', res)
      })

    },

    reloadBrandsStores: ({commit, dispatch}, user) => {
      fetchItemsNextTokenGraphQL(listBrands, {limit: 100000}).then((res) => {
        commit('SET_ALL_BRANDS', res)
        fetchItemsNextTokenGraphQL(listStores, {limit: 100000})
            .then((res) => {
            commit('SET_ALL_STORES', res)
            })
        })

    },
    initialize: ({commit, getters}) => {
      return new Promise((final_resolve, final_reject) => {
        Vue.prototype.$Amplify.Auth.currentAuthenticatedUser().then((data) => {
            if (data && data.signInUserSession) {

             fetchItemsNextTokenGraphQL(listBrands, {limit: 10000})
                .then((res) => {
                  commit('SET_ALL_BRANDS', res)
                 fetchItemsNextTokenGraphQL(listStores, {limit: 10000})
                    .then((res) => {
                      commit('SET_ALL_STORES', res)
                      fetchItemsNextTokenGraphQL(listReservations, {
                        limit: 10000,
                        filter: {owner: {eq: data.username}}
                      }).then((res) => {
                        commit('SET_ALL_RESERVATIONS', res)
                       fetchItemsNextTokenGraphQL(listFavorites, {
                          filter: {owner: {eq: data.username}},
                          limit: 10000
                        }).then((res) => {
                          commit('SET_ALL_FAVORITES', res)
                          commit('SET_USER', data)
                          var last_role = localStorage.getItem('role')
                          var last_item_id = localStorage.getItem('role_item_id')
                          var found_role = last_role ? getters.possibleRoles.find((item) => item.name == last_role) : undefined
                          if (found_role) {
                            if (found_role.name != 'System Administrator' && found_role.name != 'Visitor') {
                              var found_item_id = found_role.items.find((item) => item.id == last_item_id)
                              if (found_item_id) {
                                found_item_id = found_item_id.id
                              } else {
                                found_role = undefined
                              }
                            }
                          }


                          if (found_role) {
                            if (found_item_id) {
                              commit('SET_ROLE', {role: found_role.name, item_id: found_item_id})
                            } else {
                              commit('SET_ROLE', {role: found_role.name, item_id: undefined})
                            }
                          } else {
                            var role_to_set = getters.possibleRoles[0]
                            if (role_to_set.items.length > 0) {
                              commit('SET_ROLE', {role: role_to_set.name, item_id: role_to_set.items[0].id})
                            } else {
                              commit('SET_ROLE', {role: role_to_set.name, item_id: undefined})
                            }
                          }

                          commit("INITIALIZATION_COMPLETED")
                          commit("SET_FORCED_LOAD", false)
                          final_resolve()

                        })
                          .catch((e) => {
                            process_500_error("Can't load favorites")
                            commit("SET_FORCED_LOAD", false)
                            final_reject()
                          });
                      })
                        .catch((e) => {
                          process_500_error("Can't load reservations")
                          commit("SET_FORCED_LOAD", false)
                          final_reject()
                        });
                    })
                    .catch((e) => {
                      process_500_error("Can't load stores list")
                      commit("SET_FORCED_LOAD", false)
                      final_reject()
                    });
                })
                .catch((e) => {
                  process_500_error("Can't load brands list")
                  commit("SET_FORCED_LOAD", false)
                  final_reject()
                });
            }
          }
        ).catch((e) => {
          commit('SET_USER', null)
          commit("INITIALIZATION_COMPLETED")
          commit("SET_FORCED_LOAD", false)
          final_resolve()
        });
      })
    },
  },
  getters: {
    timezoneValues: () => {
      return [{
        'text': "Pacific Time (Los Angeles)",
        'subtext': "America/Los Angeles",
        'value': "America/Los_Angeles"
      },
        {'text': "Mountain Time (Denver)", 'subtext': "America/Denver", 'value': "America/Denver"},
        {'text': "Central Time (Chicago)", 'subtext': "America/Chicago", 'value': "America/Chicago"},
        {'text': "Eastern Time (New York)", 'subtext': "America/New York", 'value': "America/New_York"},
        {'text': "Hawaii-Aleutian Time (Honolulu)", 'subtext': "America/Honolulu", 'value': "Pacific/Honolulu"},
        {'text': "Alaska Time (Anchorage)", 'subtext': "America/Anchorage", 'value': "America/Anchorage"}]
    },
    loadingState: (state, getters) => state.loading > 0,
    currentOwnerId:(state, getters) => state.ownerId,
    currentUser: (state, getters) => state.user,
    currentUserEmail: (state, getters) => state.user ? state.user.attributes.email : '',
    groupName: (state, getters) => {
      if (state.user) {
        var groups = state.user.signInUserSession.accessToken.payload['cognito:groups']
        var found_group = 'Visitors'
        if (groups) {
          for (var group of groups) {
            if (group == 'SuperAdmins')
              found_group = 'SuperAdmins'
          }
        }
        return found_group
      }
      return 'unauthenticated'
    },
    userIsSuperAdmin: (state, getters) => getters.userIsAuthenticated ? getters.groupName == 'SuperAdmins' : false,
    userIsAuthenticated: (state, getters) => state.user ? true : false,
    currentRole: (state, getters) => state.current_role,

    isVisitor: (state, getters) => getters.currentRole == 'Visitor',
    isSecurity: (state, getters) => getters.currentRole == 'Security',
    isStoreManager: (state, getters) => getters.currentRole == 'Store Manager',
    isBrandManager: (state, getters) => getters.currentRole == 'Brand Manager',
    isSuperAdmin: (state, getters) => getters.currentRole == 'System Administrator',

    switchAvailable: (state, getters) => {
      return getters.possibleRoles.length > 1
    },

    addUserModalShown: (state, getters) => state.add_user_promise !== undefined,
    addUserEmail: (state, getters) => state.add_user_email,
    isInitialized: (state, getters) => state.initialized,
    forcedLoad: (state, getters) => state.forced_load,


    getAddress: (state, getters) => state.address,
    getTimezone: (state, getters) => state.timezone,
    getLng: (state, getters) => state.lng,
    getLat: (state, getters) => state.lat,
    error_message: (state, getters) => state.error_message,

    getCurrentBrand: (state, getters) => state.brand_id,
    getCurrentStore: (state, getters) => state.store_id,
    allBrands: (state, getters) => state.all_brands,
    allFavorites: (state, getters) => state.all_favorites,
    allReservationsByThisUser: (state, getters) => state.all_reservations,
    allStores: (state, getters) => state.all_stores,
    allStoresInCurrentBrand: (state, getters) => state.all_stores.filter((item) => item.brand_id == state.brand_id),
    getBrandById: (state, getters) => (brand_id) => state.all_brands.find((item) => item.id == brand_id),
    getStoreById: (state, getters) => (store_id) => state.all_stores.find((item) => item.id == store_id),
    getReservationById: (state, getters) => (reservation_id) => state.all_reservations.find((item) => item.id == reservation_id),
    randomData: (state, getters) => {
      let random_data = []
      for (let label of state.store_dashboard.chartdata_visitors.labels) {
        random_data.push(Math.floor((Math.random() * 5) + 1))
      }
      return random_data
    },
    possibleRoles: (state, getters) => {
      var result = [];
      var brand_manager_brands = [];
      var store_manager_stores = []
      var security_stores = []
      if (getters.userIsSuperAdmin) {
        result.push({name: 'System Administrator', items: [], display_name: 'System Administrator'})

        for (var brand of state.all_brands) {
          brand_manager_brands.push({id: brand.id, name: brand.name})
        }
        for (var store of state.all_stores) {
          store_manager_stores.push({id: store.id, name: store.name})
          security_stores.push({id: store.id, name: store.name})
        }
      } else {
        for (var brand of state.all_brands) {
          if (brand.brandmanagers.includes(getters.currentUserEmail)) {
            brand_manager_brands.push({id: brand.id, name: brand.name})
          }
        }
        for (var store of state.all_stores) {
          if (store.storemanagers.includes(getters.currentUserEmail)) {
            store_manager_stores.push({id: store.id, name: store.name})
          }
          if (store.security.includes(getters.currentUserEmail)) {
            security_stores.push({id: store.id, name: store.name})
          }
        }
      }

      if (brand_manager_brands.length > 0) {
        result.push({name: 'Brand Manager', items: brand_manager_brands, display_name: 'Brand Manager'})
      }
      if (store_manager_stores.length > 0) {
        let brands_of_stores = []
        for (let signed_to_store of store_manager_stores) {
          brands_of_stores.push(getters.getBrandById(getters.getStoreById(signed_to_store.id).brand_id).id)
        }
        let unique_brands = [...new Set(brands_of_stores)]
        if (unique_brands.length === 1) {
          let store_manager_role_name = getters.getBrandById(unique_brands[0]).store_manager_role_title
          result.push({name: 'Store Manager', items: store_manager_stores, display_name: store_manager_role_name})
        } else {
          result.push({name: 'Store Manager', items: store_manager_stores, display_name: 'Store Manager'})
        }
      }
      if (security_stores.length > 0) {
        let brands_of_stores = []
        for (let signed_to_store of security_stores) {
          brands_of_stores.push(getters.getBrandById(getters.getStoreById(signed_to_store.id).brand_id).id)
        }
        let unique_brands = [...new Set(brands_of_stores)]
        if (unique_brands.length === 1) {
          let store_security_role_name = getters.getBrandById(unique_brands[0]).security_role_title
          result.push({name: 'Security', items: security_stores, display_name: store_security_role_name})
        } else {
          result.push({name: 'Security', items: security_stores, display_name: 'Security'})
        }
      }

      result.push({name: 'Visitor', items: [], display_name: 'Visitor'})
      return result
    },
    isReservationOwner: (state, getters) => (reservation_id) => {
      var reservation = getters.allReservationsByThisUser.find((item) => item.id == reservation_id)
      if (reservation) {
        if (reservation.owner == getters.currentUser.username) {
          return true
        }
      }
      return false
    },
    isBrandManagerOfBrand: (state, getters) => (brand_id) => {
      var brand = getters.getBrandById(brand_id)
      if (brand) {
        if (brand.brandmanagers.includes(getters.currentUserEmail)) {
          return true
        }
      }
      if (getters.userIsSuperAdmin) {
        return true;
      }
      return false
    },
    isStoreManagerOfStore: (state, getters) => (store_id) => {
      if (getters.isStoreManager == false) {
        return false
      }
      if (getters.getCurrentStore != store_id) {
        return false
      }
      var store = getters.getStoreById(store_id)
      if (getters.userIsSuperAdmin) {
        return true;
      }
      if (store) {
        if (store.storemanagers.includes(getters.currentUserEmail)) {
          return true
        }
      }
      return false
    },
    isBrandManagerOfStore: (state, getters) => (store_id) => {
      var store = getters.getStoreById(store_id)
      var brand = getters.getBrandById(store.brand_id)
      if (getters.isBrandManager == false) {
        return false
      }
      if (getters.getCurrentBrand != brand.id) {
        return false
      }
      if (getters.userIsSuperAdmin) {
        return true;
      }
      if (brand) {
        if (brand.brandmanagers.includes(getters.currentUserEmail)) {
          return true
        }
      }
      return false
    },
    getDefaultPage: (state, getters) => {
      if (getters.currentRole == undefined) {
        return getters.isSuperAdmin ? {name: PAGE_IDS.BRANDS_LIST} : {name: PAGE_IDS.SEARCH}
      }
      return getters.userIsAuthenticated ?
        (getters.isSuperAdmin ? {name: PAGE_IDS.BRANDS_LIST} :
            (getters.isBrandManager ? {name: PAGE_IDS.STORES_LIST} :
                (getters.isStoreManager ? {name: PAGE_IDS.STORE_DETAILS, params: {store_id: getters.getCurrentStore}} :
                    (getters.isSecurity ? {name: PAGE_IDS.SCAN} :
                        {name: PAGE_IDS.SEARCH}
                    )
                )
            )
        ) : {'name': PAGE_IDS.AUTH}
    }
  },
  modules: {
    fakeDataStore
  }
})

export default store





// WEBPACK FOOTER //
// ./src/store/store.js